import React from "react"
import { CCPARequest } from "v2/Components/CCPARequest"

export const ReactionCCPARequest = props => <CCPARequest {...props} />
